<template>
  <div class="category">
    <el-divider content-position="left">问题分类</el-divider>
    <el-button type="primary" size="mini" @click="handleAddOpen">添加</el-button>
    <el-table height="calc(100vh - 276px)" :data="pageData" size="medium" style="width: 100%;margin-top: .2rem;" border>
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        fixed
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-dialog
      title="添加分类"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleAddClose"
    >
      <div>
        <el-row>
          <el-input placeholder="请输入分类名" v-model="addData.category_name" clearable>
          </el-input>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleAddClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑分类"
      :visible.sync="editVisible"
      width="30%"
      :before-close="handleEditClose"
    >
      <div>
        <el-row>
          <el-input placeholder="请输入分类名" v-model="editData.category_name" clearable>
          </el-input>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleEditClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Category",
  data() {
    return {
      category: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      col: [
        {
          label: "id",
          prop: "id",
        },
        {
          label: "分类名",
          prop: "category_name",
        },
      ],
      dialogVisible: false,
      editVisible: false,
      addData: {
        category_name: "",
      },
      editData: {
        id: null,
        index: null,
        category_name: "",
      },
    };
  },
  computed: {
    pageData: {
      get: function () {
        return this.category.slice(
          this.pageOption.pageSize * (this.pageOption.currentPage - 1),
          this.pageOption.pageSize * this.pageOption.currentPage
        );
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getCategory() {
      this.$axios.get("/api/admin/problemCategory").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.category = data.data;
          this.pageOption.total = this.category.length;
        }
      });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
    },
    handleAddOpen() {
      this.dialogVisible = true;
    },
    handleAdd() {
      console.log(this.addData);
      if (!this.addData.category_name) {
        this.$message.error("请输入分类名！");
        return;
      }

      this.$axios
        .post("/api/admin/problemCategory/add", {
          category_name: this.addData.category_name,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.category.push(data.data);
            this.handleAddClose();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleAddClose() {
      this.addData.category_name = "";
      this.dialogVisible = false;
    },
    handleEdit(index, row) {
      this.editData.id = row.id;
      this.editData.index = index;
      this.editData.category_name = row.category_name;
      this.editVisible = true;
    },
    handleSave() {
      if (!this.editData.id) {
        this.$message.error("请求错误！");
        return;
      }

      if (!this.editData.category_name) {
        this.$message.error("请输入分类名！");
      }

      this.$axios
        .post("/api/admin/problemCategory/save", {
          id: this.editData.id,
          category_name: this.editData.category_name,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            let idx =
              this.pageOption.pageSize * (this.pageOption.currentPage - 1) +
              this.editData.index;
            this.category[idx].category_name = this.editData.category_name;
            this.handleEditClose();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleEditClose() {
      this.editData.id = null;
      this.editData.index = null;
      this.editData.category_name = "";
      this.editVisible = false;
    },
  },
  mounted() {
    this.getCategory();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.category
  marginLeft()
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/problem/Category.vue